export default __webpack_public_path__ + "images/rebranded-empty-box-zooplus.jpg";